import { type CustomerEntity, type SiteWithAreaEntity } from '@/libs/api'

/**
 * 荷主と地点を関連付ける際に書き込むコードを解決する（#3669）。
 * 荷主に既にコードが設定済みならそのコードを、未設定なら荷主名称をそのまま使う。
 */
export const resolveSiteGroupCode = (customer: CustomerEntity) =>
  customer.siteGroupCode && customer.siteGroupCode !== ''
    ? customer.siteGroupCode
    : customer.name

/**
 * 地点が既に選択中荷主と関連付け済みかどうかを判定する（#3669）。
 * 荷主自身に実コードがまだ設定されていない間は、たとえ地点側のコードが
 * resolveSiteGroupCode の解決結果（荷主名称の仮コード）と一致していても
 * 「関連付け済み」とは扱わない。バックフィル（荷主側の更新）だけが失敗した
 * 部分失敗状態で「済み」と誤判定すると、ボタンが disabled になり
 * ユーザーが再試行できなくなるため（Copilot レビュー指摘、PR #5133）。
 */
export const isSiteAlreadyLinkedToCustomer = (
  site: SiteWithAreaEntity,
  customer: CustomerEntity
) =>
  !!customer.siteGroupCode &&
  customer.siteGroupCode !== '' &&
  site.siteGroupCode === customer.siteGroupCode
